/**
 * FVrad app constants and default thresholds
 */

export const APP_NAME = 'FVrad';

/** Default annual dose alert threshold (6 mSv in µSv) - frequent flyer guideline */
export const DEFAULT_ALERT_THRESHOLD_MICRO_SV = 6_000_000;

/** Alert when dose rate exceeds this (µSv/h) - e.g. high-altitude polar route */
export const DEFAULT_DOSE_RATE_ALERT_MICRO_SV_PER_HOUR = 5;

/** Alert when cumulative annual dose exceeds 1 mSv (µSv) */
export const DEFAULT_ANNUAL_CUMULATIVE_ALERT_MICRO_SV = 1_000_000;

/** Typical cruise altitude in feet for commercial flights */
export const DEFAULT_CRUISE_ALTITUDE_FEET = 35_000;

/** ICRP occupational annual limit (mSv) - crew compliance reference */
export const ICRP_ANNUAL_LIMIT_MSV = 6;
